import { DateTime } from 'luxon';

export default function (weekDay) {
  if (!weekDay) return 'N/A';
  return DateTime.fromISO(weekDay).toFormat('cccc');
}
